import { Button, TextField, Box } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useEffect, useMemo, useState } from 'react'
import Dashboard from '../../components/Dashboard'
import DescargablesTable from '../../components/Descargables/Table'
import useFetchDescargables from '../../hooks/useFetchDescargables'
import { useDescargablesContext } from '../../context/DescargablesContext'
import BtnExportHistorial from '../../components/Descargables/Historial/BtnExportHistorial'

const DescargablesPage = () => {

  const navigate = useNavigate()
  useFetchDescargables()
  const { descargables } = useDescargablesContext()
  //const [descargablesFiltrados, setDescargablesFiltrados] = useState<any[]>([])
  const [filtroBusqueda, setFiltroBusqueda] = useState('')

  const descargablesFiltrados = useMemo(() => {
    if (filtroBusqueda.trim() === '') {
      return [...descargables]
        .filter(des => des?.activo)
        .sort((a, b) => new Date(b?.fechaRegistro).getTime() - new Date(a?.fechaRegistro).getTime())
    } else {
      return descargables?.filter(descargable => {
          const titulo = (descargable?.titulo || '').toString().toLowerCase()
          const sku = (descargable?.sku || '').toString().toLowerCase()
          const busqueda = filtroBusqueda.toLowerCase()
          
          return titulo.includes(busqueda) || sku.includes(busqueda)
        })
        .filter(des => des?.activo)
        .sort((a, b) => new Date(b?.fechaRegistro).getTime() - new Date(a?.fechaRegistro).getTime())
    }
  }, [filtroBusqueda, descargables])

  return (
    <Dashboard>
       <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        margin:'2% 0'
      }}>
      <h1>DESCARGABLES</h1>
      
      <div style={{display: 'flex', gap: '10px', }}>
        <Button variant='contained' color='success' style={{marginBottom: '20px', background: '#000',
            fontFamily: 'WorkSans',
            fontWeight: '500',
            fontSize: '14px',
            lineHeight: '16px',
            textAlign: 'center',
            textTransform: 'uppercase',
            color: '#FFF',
            padding: '17px 62px',
            border: 'none',
            cursor: 'pointer', }} onClick={() => {
          navigate("/descargable/nuevo")
        }} >
          Nuevo descargable
        </Button>

        <BtnExportHistorial />
      </div>

        
      </div>

      <Box sx={{ marginBottom: '20px', maxWidth: '400px' }}>
        <TextField
          fullWidth
          label="Buscar por título o SKU"
          variant="outlined"
          value={filtroBusqueda}
          onChange={(e) => setFiltroBusqueda(e.target.value)}
          placeholder="Ingresa el título del descargable o SKU..."
          sx={{
            '& .MuiOutlinedInput-root': {
              fontFamily: 'WorkSans',
              fontSize: '14px',
            },
            '& .MuiInputLabel-root': {
              fontFamily: 'WorkSans',
              fontSize: '14px',
            }
          }}
        />
      </Box>
      
        <DescargablesTable descargablesFiltrados={descargablesFiltrados} />
    </Dashboard>
  )
}

export default DescargablesPage